import { Action } from '@ngrx/store';

export enum resetPassActionTypes {
    RESET_STATUS = '[resetPass] Reset Status',
    DO_RESET = '[resetPass] Do Reset',
    DO_RESET_SUCCESS = '[resetPass] Do Reset Success',
    DO_RESET_FAIL = '[resetPass] Do Reset Fail',
}


export class ResetStatus implements Action {
    readonly type = resetPassActionTypes.RESET_STATUS;
    constructor() { }
}


export class DoReset implements Action {
    readonly type = resetPassActionTypes.DO_RESET;
    constructor(public payload: {
        token: string,
        password: string
    }) { }
}


export class DoResetSuccess implements Action {
    readonly type = resetPassActionTypes.DO_RESET_SUCCESS;
    constructor(public payload: any) { }
}


export class DoResetFail implements Action {
    readonly type = resetPassActionTypes.DO_RESET_FAIL;
    constructor(public error: number) { }
}


export type resetPassActions = DoReset | DoResetSuccess | DoResetFail;
